import { Box, SxProps } from '@mui/material';
import { grey, red, teal } from '@mui/material/colors';
import React, { CSSProperties } from 'react';

export interface PolarityBarProps {
  percentage: number;
  sx?: SxProps;
  type: 'positive' | 'negative';
}

const PolarityBar = ({ percentage, sx = {}, type }: PolarityBarProps) => (
  <Box
    style={
      {
        '--left-color': { negative: red[400], positive: grey[200] }[type],
        '--right-color': { negative: grey[200], positive: teal[400] }[type],
      } as CSSProperties
    }
    sx={{
      backgroundColor: grey[200],
      backgroundImage:
        percentage !== 0
          ? type === 'positive'
            ? `linear-gradient(to right, var(--left-color) 0%, var(--left-color) 50%, var(--right-color) 50%, var(--right-color) ${
                50 + percentage / 2
              }%, var(--left-color) ${50 + percentage / 2}%);`
            : `linear-gradient(to right,var(--right-color) ${50 - percentage / 2}%,var(--left-color) ${
                50 - percentage / 2
              }%, var(--left-color) 50%, var(--right-color) 50%, var(--right-color) 100%);`
          : '',
      borderRadius: 20,
      height: 8,
      position: 'relative',
      ...sx,
    }}
  />
);

export default PolarityBar;
